export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OurTeam.vue?vue&type=template&id=12b385a2&"


//////////////////
// WEBPACK FOOTER
// ./src/views/static/OurTeam.vue?vue&type=template&id=12b385a2&
// module id = 527
// module chunks = 4